var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p-button',{attrs:{"outline":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.$router.back()}}},[_vm._v(" ← "+_vm._s(_vm.$t('Back'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }